import { apiClient } from '../../lib/util';
import { useInfiniteQuery } from '@tanstack/react-query';

export const useListEmployeesByGroup = (
  companyId?: string,
  groupId?: string,
  negated = false,
  options = {}
) => {
  const groupsParam = negated ? `!${groupId}` : (groupId ?? '');

  return useInfiniteQuery({
    queryKey: ['employees', 'group', companyId ?? 'MISSING_COMPANY_ID', groupsParam],
    queryFn: async () => {
      let allEmployees = [];
      let result = await apiClient.employees.employeesList({
        company: companyId ?? '',
        groups: groupsParam
      });

      allEmployees = [...result.results];

      while (result.next) {
        const nextOffset = new URL(result.next).searchParams.get('offset');
        result = await apiClient.employees.employeesList({
          company: companyId ?? '',
          groups: groupsParam,
          offset: parseInt(nextOffset ?? '0')
        });
        allEmployees = [...allEmployees, ...result.results];
      }

      return allEmployees;
    },
    getNextPageParam: () => undefined,
    initialPageParam: 0,
    enabled: !!companyId && !!groupId,
    ...options
  });
};
